export const attributeGroups = [
  {
    name: 'Learning framework',
    isFilterOption: true, // FIXME: Temporary solution to display only allowed options to use in filter
    rows: [
      [
        {
          attribute: 'L&D Strategic Area Model - Area',
          isFilterOption: false,
          values: [
            'Innovation & Digitalization',
            'Leadership & talent development',
            'Professional training',
            'Team & culture development',
          ],
        },
        {
          attribute: 'Cognitive Levels',
          isFilterOption: true,
          values: ['Awareness', 'Understanding', 'Insight', 'Behaviour'],
        },
      ],
    ],
  },
  {
    name: 'Grow at SEB',
    isFilterOption: false,
    rows: [
      [
        {
          attribute: 'School Term',
          isFilterOption: false,
          values: ['Autumn', 'Spring'],
        },
        {
          attribute: 'School Year',
          isFilterOption: false,
          values: ['2018', '2019', '2020', '2021', '2022', '2023', '2024', '2025', '2026', '2027', '2028', '2029', '2030'],
        },
        {
          attribute: 'Yearly Competence Update',
          isFilterOption: false,
          values: [
            '2005',
            '2006',
            '2007',
            '2008',
            '2009',
            '2010',
            '2011',
            '2012',
            '2013',
            '2014',
            '2015',
            '2016',
            '2017',
            '2018',
            '2019',
            '2020',
            '2021',
            '2022',
            '2023',
            '2024',
            '2025',
          ],
        },
      ],
    ],
  },
  {
    name: 'Strategies & Culture',
    isFilterOption: true,
    rows: [
      [
        {
          attribute: 'HR focus areas',
          isFilterOption: false,
          values: ['Continuous learning', 'Dynamic talent market', 'Transformative leadership', 'Reshaping work'],
        },
        {
          attribute: 'WFP Critical Competencies',
          isFilterOption: true,
          deactivated: [
            'Agile WoW & Service design',
            'Change management',
            'Credit skills',
            'Customer understanding',
            'Digital awareness',
            'End-to-end processing',
            'Leadership skills',
            'Strategic thinking',
            'Sustainability',
            'Technology skills',
            'Advisory skills & Business acumen',
            'Digital Sales & Remote Advisory',
            'Agile WoW & E2E processing',
            'Business Development & Partnership Management',
            'Credit competence',
            'Dev Sec Ops',
            'Flexible & Hybrid WoW',
            'Innovation Skills',
            'Sector & Product knowledge',
            'Technology skills & Digital adoption',
          ],
          values: [
            'AI',
            'Advisory & Sales',
            'AML/Financial Crime sector knowledge',
            'Business Acumen',
            'Cloud',
            'Collaboration',
            'Communication',
            'Cyber Security',
            'Data Management & Data Analytics',
            'Digital Literacy & Tech Proficiency',
            'Inclusion & Diversity',
            'Process/ Project Management',
            'Risk & Regulatory skills',
            'Sustainability/Sustainable Banking',
            'Transformative Leadership & Change Management',
          ],
        },
        {
          attribute: 'SEB Behaviors',
          isFilterOption: false,
          values: ['Create value', 'Act long-term', 'Build positive relationships'],
        },
        {
          attribute: 'Service Style',
          isFilterOption: false,
          values: ['Education', 'Process', 'Motivation', 'Guidance', 'Inspiration', 'Innovation'],
        },
        {
          attribute: 'Keywords',
          isFilterOption: false,
          values: [
            'Agility',
            'Cross collaboration',
            'Engagement',
            'Feedback culture',
            'Inclusion & diversity',
            'Innovation',
            'Speed',
            'Sustainability',
            'Teamwork',
            'Transformation',
          ],
        },
      ],
    ],
  },
  {
    name: 'Leadership & Required',
    isFilterOption: false,
    rows: [
      [
        {
          attribute: 'Transformative Leadership',
          isFilterOption: false,
          values: [
            'Be curious – Listen emphatically',
            'Speak your mind – Create psychological safety',
            'Co-create clarity – Set strategic frames',
            'Release potential – Share power',
            'Smarter together – Learn continuously',
            'Energise – Inspire by a bigger purpose',
            'About transformative leadership',
          ],
        },
        {
          attribute: 'Required Type',
          isFilterOption: false,
          values: ['Mandatory by Segment', 'Business Demanded', 'SEB Mandatory'],
        },
      ],
      [
        {
          attribute: 'Regulation',
          isFilterOption: false,
          values: [
            'AI Act',
            'ÅKU',
            'AML/CTF',
            'BFAA',
            'Code of Conduct',
            'Dodd-Frank',
            'Dora',
            'EMIR',
            'FATCA',
            'Fraud Awareness',
            'GDPR',
            'IDD',
            'Local Health and Safety',
            'Market abuse',
            'MiFid',
            'ORSA',
            'PCI DSS',
            'PRIIP',
            'RTSA',
            'Sanctions',
            'Security at SEB',
            'Sexual Harassment',
            'Swedsec',
            'Violence and Harassment prevention',
            'Other',
          ],
        },
        {
          attribute: 'Division & Business Area',
          isFilterOption: false,
          values: [
            'Asset Management',
            'Baltic',
            'Business and Retail Banking',
            'Corporate and Investment Banking',
            'Life',
            'Private Wealth Management',
            'Other',
          ],
        },
        {
          attribute: 'Retake Cycle',
          isFilterOption: false,
          values: ['Only once', 'Semi annual', 'Annual', '2 yr', '3 yr', '4 yr', '5 yr', 'Other'],
        },
      ],
    ],
  },
];
